export default __webpack_public_path__ + "static/media/Ethereum-Icon-Purple-Logo.8c8bb8f1.svg";